var _g, _path, _g2, _g3, _path2, _path3, _path4, _path5, _path6, _path7, _g4, _g5, _g6, _g7, _path8, _path9, _path0, _path1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWatching(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 162,
    viewBox: "0 0 119 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5319_3105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.392 150.821H11.2986C8.61809 150.821 6.44531 148.649 6.44531 145.968V49.8748C6.44531 47.1943 8.61809 45.0215 11.2986 45.0215H107.392C110.072 45.0215 112.245 47.1943 112.245 49.8748V145.968C112.245 148.649 110.072 150.821 107.392 150.821Z",
    fill: "#BCE0F5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.242 136.113V145.969C112.242 148.649 110.07 150.822 107.389 150.822H11.2983C8.61779 150.822 6.44531 148.649 6.44531 145.969V136.113C6.44531 138.794 8.61779 140.969 11.2983 140.969H107.389C110.07 140.969 112.242 138.794 112.242 136.113Z",
    fill: "#2A7182"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5319_3105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.208 56.0996H17.4766V130.308H101.208V56.0996Z",
    fill: "#9DA5A8"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_5319_3105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.21 56.0977V65.2L36.1024 130.307H17.4785V114.239L75.6173 56.0977H101.21Z",
    fill: "#CBCFD1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5633 140.732C31.5633 143.091 29.6502 145.004 27.2883 145.004C24.9287 145.004 23.0156 143.091 23.0156 140.732C23.0156 140.105 23.1498 139.509 23.3939 138.973C24.0645 137.488 25.5557 136.457 27.2883 136.457C29.0233 136.457 30.5141 137.488 31.1826 138.973C31.427 139.509 31.5633 140.105 31.5633 140.732Z",
    fill: "#E5B045"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1832 138.973C30.5147 140.455 29.0239 141.486 27.2889 141.486C25.556 141.486 24.0651 140.455 23.3945 138.973C24.0651 137.488 25.5563 136.457 27.2889 136.457C29.0239 136.457 30.5147 137.488 31.1832 138.973Z",
    fill: "#F5C350"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8074 140.732C46.8074 143.091 44.8943 145.004 42.5324 145.004C40.1729 145.004 38.2598 143.091 38.2598 140.732C38.2598 140.105 38.3939 139.509 38.6381 138.973C39.3087 137.488 40.7998 136.457 42.5324 136.457C44.2674 136.457 45.7583 137.488 46.4267 138.973C46.6712 139.509 46.8074 140.105 46.8074 140.732Z",
    fill: "#52A397"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4273 138.973C45.7588 140.455 44.268 141.486 42.533 141.486C40.8001 141.486 39.3092 140.455 38.6387 138.973C39.3092 137.488 40.8004 136.457 42.533 136.457C44.268 136.457 45.7588 137.488 46.4273 138.973Z",
    fill: "#61B4AA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0516 140.732C62.0516 143.091 60.1385 145.004 57.7766 145.004C55.417 145.004 53.5039 143.091 53.5039 140.732C53.5039 140.105 53.6381 139.509 53.8822 138.973C54.5528 137.488 56.0439 136.457 57.7766 136.457C59.5115 136.457 61.0024 137.488 61.6712 138.973C61.9153 139.509 62.0516 140.105 62.0516 140.732Z",
    fill: "#F6F6F6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6718 138.973C61.0033 140.455 59.5124 141.486 57.7771 141.486C56.0442 141.486 54.5534 140.455 53.8828 138.973C54.5534 137.488 56.0445 136.457 57.7771 136.457C59.5121 136.457 61.0033 137.488 61.6718 138.973Z",
    fill: "#E66480"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_5319_3105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.2179 35.1689H46.8086V45.0225H72.2179V35.1689Z",
    fill: "#2A7182"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_5319_3105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.2179 39.8906H46.8086V45.0215H72.2179V39.8906Z",
    fill: "#2A7182"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_5319_3105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.244 119.448C113.482 119.448 114.486 118.444 114.486 117.207V49.8751C114.486 45.9631 111.303 42.7806 107.391 42.7806H74.4591V35.1683C74.4591 33.9305 73.4556 32.9271 72.2179 32.9271H65.6652L82.2654 9.08057L82.6126 9.34115C83.0158 9.64356 83.4876 9.78939 83.9556 9.78939C84.6369 9.78939 85.3102 9.4798 85.7503 8.8929C86.4929 7.90259 86.2921 6.4978 85.3021 5.75521L80.641 2.25892C79.6509 1.51663 78.2459 1.71714 77.5033 2.70716C76.7607 3.69748 76.9615 5.10227 77.9515 5.84486L78.6774 6.38902L60.2038 32.9268H58.6622L32.5261 4.67524L33.2973 4.09671C34.2876 3.35413 34.4882 1.94904 33.7456 0.959018C33.003 -0.0309998 31.5982 -0.231812 30.6079 0.510776L25.9468 4.00677C24.9564 4.74935 24.7559 6.15444 25.4985 7.14446C25.939 7.73166 26.6119 8.04095 27.2933 8.04095C27.7612 8.04095 28.2331 7.89482 28.6362 7.5927L28.921 7.37904L52.5556 32.9268H46.8082C45.5705 32.9268 44.567 33.9302 44.567 35.168V42.7803H11.2976C7.38565 42.7803 4.20312 45.9628 4.20312 49.8748V145.968C4.20312 149.88 7.38565 153.063 11.2976 153.063H107.391C111.303 153.063 114.486 149.88 114.486 145.968V125.869C114.486 124.632 113.482 123.628 112.244 123.628C111.007 123.628 110.003 124.632 110.003 125.869V145.968C110.003 147.409 108.832 148.58 107.391 148.58H11.2976C9.85725 148.58 8.68555 147.409 8.68555 145.968V49.8751C8.68555 48.4347 9.85725 47.263 11.2976 47.263H107.391C108.831 47.263 110.003 48.4347 110.003 49.8751V117.207C110.003 118.445 111.007 119.448 112.244 119.448ZM69.9767 37.4095V42.7806H49.0495V37.4095H69.9767Z",
    fill: "black"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_5319_3105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.452 130.308V56.0986C103.452 54.8609 102.448 53.8574 101.211 53.8574H17.4795C16.2417 53.8574 15.2383 54.8609 15.2383 56.0986V73.1471C15.2383 74.3848 16.2417 75.3883 17.4795 75.3883C18.7172 75.3883 19.7207 74.3848 19.7207 73.1471V58.3398H98.969V128.066H19.7207V82.8375C19.7207 81.5997 18.7172 80.5963 17.4795 80.5963C16.2417 80.5963 15.2383 81.5997 15.2383 82.8375V130.308C15.2383 131.545 16.2417 132.549 17.4795 132.549H101.21C102.448 132.549 103.452 131.545 103.452 130.308Z",
    fill: "black"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7754 140.731C20.7754 144.323 23.6976 147.246 27.2898 147.246C30.8821 147.246 33.8043 144.323 33.8043 140.731C33.8043 137.139 30.8821 134.217 27.2898 134.217C23.6976 134.217 20.7754 137.139 20.7754 140.731ZM29.3219 140.731C29.3219 141.852 28.4104 142.763 27.2898 142.763C26.1692 142.763 25.2578 141.852 25.2578 140.731C25.2578 139.611 26.1692 138.699 27.2898 138.699C28.4104 138.699 29.3219 139.611 29.3219 140.731Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0195 140.731C36.0195 144.323 38.9418 147.246 42.534 147.246C46.1262 147.246 49.0484 144.323 49.0484 140.731C49.0484 137.139 46.1262 134.217 42.534 134.217C38.9418 134.217 36.0195 137.139 36.0195 140.731ZM44.5657 140.731C44.5657 141.852 43.6543 142.763 42.5337 142.763C41.4131 142.763 40.5017 141.852 40.5017 140.731C40.5017 139.611 41.4131 138.699 42.5337 138.699C43.6543 138.699 44.5657 139.611 44.5657 140.731Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2637 140.731C51.2637 144.323 54.1859 147.246 57.7781 147.246C61.3703 147.246 64.2926 144.323 64.2926 140.731C64.2926 137.139 61.3703 134.217 57.7781 134.217C54.1859 134.217 51.2637 137.139 51.2637 140.731ZM59.8102 140.731C59.8102 141.852 58.8987 142.763 57.7781 142.763C56.6575 142.763 55.7461 141.852 55.7461 140.731C55.7461 139.611 56.6575 138.699 57.7781 138.699C58.8987 138.699 59.8102 139.611 59.8102 140.731Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7998 138.556C69.5621 138.556 68.5586 139.559 68.5586 140.797C68.5586 142.035 69.5621 143.038 70.7998 143.038H100.085C101.323 143.038 102.326 142.035 102.326 140.797C102.326 139.559 101.323 138.556 100.085 138.556H70.7998Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5319_3105",
    x: 2.44531,
    y: 45.0215,
    width: 113.801,
    height: 113.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5319_3105"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5319_3105",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5319_3105",
    x: 13.4766,
    y: 56.0996,
    width: 91.7324,
    height: 82.208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5319_3105"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5319_3105",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5319_3105",
    x: 13.4785,
    y: 56.0977,
    width: 91.7305,
    height: 82.209,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5319_3105"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5319_3105",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_5319_3105",
    x: 42.8086,
    y: 35.1689,
    width: 33.4102,
    height: 17.8535,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5319_3105"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5319_3105",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_5319_3105",
    x: 42.8086,
    y: 39.8906,
    width: 33.4102,
    height: 13.1309,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5319_3105"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5319_3105",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_5319_3105",
    x: 0.203125,
    y: 0.0625,
    width: 118.283,
    height: 161,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5319_3105"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5319_3105",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_5319_3105",
    x: 11.2383,
    y: 53.8574,
    width: 96.2129,
    height: 86.6914,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5319_3105"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5319_3105",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatching);
export default __webpack_public_path__ + "static/media/watching.f00b6e42c0c2e68f0c46ecd41e49cab5.svg";
export { ForwardRef as ReactComponent };